export default {
  namespaced: true,
  state: {
    access_token: "",
    dialog_show: false
  },
  actions: {

  },
  mutations: {
    UPDATETOKENS(state, value) {
      state.access_token = value;
    },
    SHOWDIALOG(state, value) {
      console.log(value);
      state.dialog_show = value;
    }
  }
};
